import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import InputGroup from '../../../../../components/global/InputGroup';
import { getAsset } from '../../../../../util/assets';
import Alert from '../../../../../components/global/Alert';
import Button from '../../../../../components/global/Button';
import Spinner from '../../../../../components/global/Spinner';
import { canRequestMagicLink } from '../../../../../util/product-permissions';

const propTypes = {
  onSubmit: PropTypes.func.isRequired,
  values: PropTypes.shape({
    email: PropTypes.string,
    password: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  loading: PropTypes.bool,
  isFormValid: PropTypes.bool,
  onSendMagicLink: PropTypes.func.isRequired,
  onTeamLogin: PropTypes.func.isRequired,
  signupDisabled: PropTypes.bool,
};

const AuthModeEmail = ({
  onSubmit,
  values,
  onChange,
  error,
  loading,
  isFormValid,
  onSendMagicLink,
  onTeamLogin,
  signupDisabled,
}) => {
  return (
    <Fragment>
      <form className="login-form" onSubmit={onSubmit}>
        <InputGroup
          id="email"
          type="email"
          name="email"
          addon={<img alt="" src={getAsset('/shutterbug/icons/email.svg')} />}
          placeholder="Your email address"
          value={values.email}
          onChange={({ target }) => onChange('email', target.value)}
          wrapperClassName="mb-1"
          data-testid="email-input"
        />

        {error && (
          <Alert type="danger" className="mt-2">
            <strong>Signing in wasn&apos;t successful</strong>
            <br />
            {error}
          </Alert>
        )}
        <div className="text-center">
          <Button
            type="submit"
            className="mt-4 mb-1 login-email-form-button"
            disabled={loading || !isFormValid}
            data-testid="sign-in-button"
          >
            {!loading ? 'Log in' : <Spinner light size="xs" />}
          </Button>
          {!signupDisabled && (
            <p className="mb-0 text-sm mt-2">
              Need an account for your business?
              <br />
              <a href="/auth/register">Sign up here &rarr;</a>
            </p>
          )}
          <p className="mb-0 text-sm mt-2">
            <Button
              onClick={onTeamLogin}
              btnStyle="link"
              btnSize="sm"
              data-testid="team-login-link"
            >
              Logging in as a team member?
            </Button>
          </p>
          <hr />
        </div>
      </form>
      {canRequestMagicLink() && (
        <Fragment>
          <div className="email-link-header">Magic Link</div>
          <p>
            We can email you a magic link so you can sign in without having to
            type your password.
          </p>
          <Button
            onClick={onSendMagicLink}
            btnStyle="link"
            className="text-bold"
            data-testid="magic-link-option"
          >
            Email me a magic link
          </Button>
        </Fragment>
      )}
    </Fragment>
  );
};

AuthModeEmail.propTypes = propTypes;

export default AuthModeEmail;
